import Order from "../../features/User/Order";
function OrderPage() {
    return (
        <Order />
    );
}

export default OrderPage;